import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AgeVerificationModal from '../components/AgeVerificationModal';
import SeriesCard from '../components/SeriesCard';
import { Loader2, ShieldAlert } from 'lucide-react';

const BACKEND_URL = '';  // Use relative URLs
const API = '/api';

const MaturePage = () => {
  const navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [series, setSeries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user has previously verified
    const verified = localStorage.getItem('ageVerified') === 'true';
    if (verified) {
      setIsVerified(true);
      fetchMatureContent();
    } else {
      setShowModal(true);
      setLoading(false);
    }
  }, []);

  const fetchMatureContent = async () => {
    setLoading(true);
    try {
      // Fetch series with mature tag
      const response = await axios.get(`${API}/series?tags=mature&limit=50`);
      setSeries(response.data);
    } catch (error) {
      console.error('Error fetching mature content:', error);
      setSeries([]);
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = () => {
    setIsVerified(true);
    setShowModal(false);
    fetchMatureContent();
  };

  const handleCancel = () => {
    setShowModal(false);
    navigate('/');
  };

  if (!isVerified) {
    return (
      <>
        <div className="min-h-screen bg-black flex items-center justify-center">
          <div className="text-center">
            <ShieldAlert className="w-24 h-24 text-red-500 mx-auto mb-6" />
            <h1 className="text-3xl font-black text-white mb-4">Mature Content</h1>
            <p className="text-gray-400">Age verification required</p>
          </div>
        </div>
        <AgeVerificationModal
          isOpen={showModal}
          onVerify={handleVerify}
          onCancel={handleCancel}
        />
      </>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      {/* Content */}
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 py-8">
        
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-4">
            <ShieldAlert className="w-8 h-8 text-red-500" />
            <h1 className="text-3xl font-black text-white">Mature Content (18+)</h1>
          </div>
          <p className="text-gray-400">
            Stories with mature themes, violence, or adult content
          </p>
        </div>

        {/* Loading State */}
        {loading ? (
          <div className="flex justify-center items-center py-20">
            <Loader2 className="w-8 h-8 text-orange-500 animate-spin" />
          </div>
        ) : series.length === 0 ? (
          /* Empty State */
          <div className="text-center py-20">
            <div className="text-6xl mb-4">🔞</div>
            <h2 className="text-2xl font-bold text-white mb-2">No Mature Content Yet</h2>
            <p className="text-gray-400 mb-6">Check back later for new mature series</p>
            <Link 
              to="/comics" 
              className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold px-6 py-3 rounded-lg transition-colors"
            >
              Browse All Comics
            </Link>
          </div>
        ) : (
          /* Series Grid */
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6">
            {series.map((item) => (
              <SeriesCard key={item.id} series={item} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MaturePage;
